import React, { Component } from "react";
import { MyFlowsAdministrationView } from "../../views";

class MyFlowsAdministrationAction extends Component {
    constructor(props){
        super(props)
        this.state = {
            headerTitle: 'Administración de mis flujos'
        }
    }

    render(){
        return(
            <MyFlowsAdministrationView
                {...this.state}
                {...this.props}
            />
        )
    }
}

export { MyFlowsAdministrationAction as default }